import styled from 'styled-components'

export const StyledHeaderName = styled.div`
  text-transform: capitalize;
`

export const ActionsContainer = styled.div`
  display: flex;
  align-items: flex-end;
  margin-left: auto;
`
